import _ from "./ghl-ui.es1208.js";
import e from "./ghl-ui.es733.js";
import r from "./ghl-ui.es1180.js";
var h = 200;
function m(i, s) {
  var t = this.__data__;
  if (t instanceof _) {
    var a = t.__data__;
    if (!e || a.length < h - 1)
      return a.push([i, s]), this.size = ++t.size, this;
    t = this.__data__ = new r(a);
  }
  return t.set(i, s), this.size = t.size, this;
}
export {
  m as default
};
